import internalApiClient from '~/app/shared/util/api/internalApiClient';
import { sanitizeCVRNumber, trackSmartPaySignupError } from './utils';
import { SmartPayCustomerType, SmartPayIntegrationError, SmartPayOnboardingFormData } from '../../../types';

export const getCheckCustomer = async (cvr: string) => {
    try {
        return await internalApiClient.get(`/smartpay/checkCustomer?cvr=${sanitizeCVRNumber(cvr)}`);
    } catch (e) {
        return Promise.reject(e);
    }
};

export const postSubscribeToNewsletter = async (email: string, consentedText: string) => {
    try {
        await internalApiClient.post('/Users/subscribeSmartPay', { email, marketingConsentText: consentedText });
    } catch (error) {
        trackSmartPaySignupError(SmartPayIntegrationError.NEWSLETTER_SUBSCRIBE);
    }
};

export const postOnboardingInfo = async (
    formData: Partial<SmartPayOnboardingFormData> | null,
    customerType: SmartPayCustomerType
) => {
    if (!formData) return;

    try {
        const onboardingPayload = {
            CustomerType: customerType,
            Daybook: formData.journalNumber === 0 ? null : formData.journalNumber, // Backend will create a new journal for SmartPay when null is sent
            PaymentAccount: formData.bankAccount,
            FeeAccount: formData.feeJournalNumber,
            Cvr: sanitizeCVRNumber(formData.cvr || ''),
            Telephone: formData.phone,
            Email: formData.email,
            CustomerNumber: formData.nfCustomerNumber,
            FirstName: formData.firstName,
            LastName: formData.lastName,
            SubscriptionType: formData.subscriptionType,
        };

        return await internalApiClient.post('/smartpay/initiateOnboarding', onboardingPayload);
    } catch (e) {
        let errorMessage = 'GENERIC_ERROR_MESSAGE';

        if (e.response?.message) {
            errorMessage = e.response.message;
        }

        if (e.response?.data?.message) {
            errorMessage = e.response.data.message;
        }

        if (e.response?.data?.daybook?.length > 0) {
            const [daybookError] = e.response.data.daybook;
            errorMessage = daybookError;
        }

        trackSmartPaySignupError(errorMessage);

        return Promise.reject(errorMessage);
    }
};
